const RelatedResources = () => {
    const relatedResources = document.querySelectorAll('.related_resource .resource_grid__items_card');

    if (!relatedResources) {
        return;
    }
    relatedResources.forEach(function (card) {
        card.addEventListener('click', function (event) {
            const clickedElement = event.target;
            if (!clickedElement || !clickedElement.closest) {
                return;
            }

            // Respect native behavior for interactive elements inside the card.
            if (clickedElement.closest('a, button, input, select, textarea, label')) {
                return;
            }

            const cardLink = card.querySelector('.resource_grid__items_card_link[href]');
            if (!cardLink) {
                return;
            }

            cardLink.click();
        });
    });
};

export default RelatedResources;
